export default __webpack_public_path__ + "static/media/PratibhaRajpurohit.207b2c45.jpeg";